<ng-container *ngIf="totalCount; then lengthDescription; else noLengthDescription"> </ng-container>
<ng-template #lengthDescription>
  <p class="fc-paginator__description">
    {{
      'PAGINATOR.DESCRIPTION'
        | translate
          : {
              totalCount: totalCount,
              from: from,
              until: until
            }
    }}
  </p>
</ng-template>
<ng-template #noLengthDescription>
  <p class="fc-paginator__description">
    {{
      'PAGINATOR.NO_LENGTH_DESCRIPTION'
        | translate
          : {
              from: from,
              until: until
            }
    }}
  </p>
</ng-template>

<button
  class="fc-paginator__button"
  [color]="'primary'"
  mat-stroked-button
  [disabled]="isFirstPage || isLoading"
  [class.disabled]="isFirstPage || isLoading"
  (click)="previousPage()"
>
  {{ 'PAGINATOR.PREVIOUS' | translate }}
</button>

<button
  class="fc-paginator__button"
  mat-stroked-button
  [color]="'primary'"
  [disabled]="isLastPage || isLoading"
  [class.disabled]="isLastPage || isLoading"
  (click)="nextPage()"
>
  {{ 'PAGINATOR.NEXT' | translate }}
</button>
